import { render, staticRenderFns } from "./AdminEmbroideryCategoriesNewScreen.vue?vue&type=template&id=323982d6&scoped=true&"
import script from "./AdminEmbroideryCategoriesNewScreen.vue?vue&type=script&lang=js&"
export * from "./AdminEmbroideryCategoriesNewScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323982d6",
  null
  
)

export default component.exports